import { Component, OnInit, ElementRef, ViewChild, OnDestroy, AfterViewInit } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { MaterialsService } from '../../data/materials.service';
import { MaterialsResponcePage } from '../../data/materials-response-page';
import { MaterialPage } from '../../data/materials-page';
import { environment } from 'projects/desktop/src/environments/environment';
import { MaterialType } from '../../data/material-type';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { VendorsService } from '../../data/vendors.service';
import { Subject, Subscription, timer } from 'rxjs';
import { LocalStorage } from 'ngx-webstorage';
import { Table } from 'primeng/table';
import { ActivatedRoute, Router } from '@angular/router';
import { MatOrderQuery } from '../../../order/data/mat-order.query';
import { MatOrderStore } from '../../../order/data/mat-order.store';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-materials-page',
  templateUrl: './materials-page.component.html',
  styleUrls: ['./materials-page.component.scss']
})
export class MaterialsPageComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('mt', {static: true})
  materialsTable: Table;

  materials: MaterialPage[];
  materialsResponcePage: MaterialsResponcePage;

  @LocalStorage()
  selectedMaterialCols: string[];

  materialsCols: any[] = [];
  allMaterialsCols: any[];

  materialsColsMap = new Map();
  materialsShowsMap = new Map();

  types: SelectItem[] = [];
  typeItems: SelectItem[];

  vendors: SelectItem[] = [];
  vendorItems: SelectItem[];
  selectedVendors: any[] = [];
  vendorFiltersLabel = '{0} vendors selected';

  @LocalStorage()
  storedVendorIds: number[];

  @LocalStorage()
  storedTypeIds: number[];

  units: SelectItem[];
  unitItems: SelectItem[];

  colors: SelectItem[];

  yearFilter: number;
  yearTimeout: any;

  loadings = [];

  totalElems: number;
  matPerPage = 16;

  showTypes: boolean;
  selectedTypes: any[] = [];
  typeFiltersLabel = '{0} types selected';

  editSubj = new Subject<MaterialPage>();
  loadSubj = new Subject<void>();
  searchQuery: string;

  first: number;
  rows: number;
  footerString: string;

  matSearchSubj: Subscription;

  createMaterialLoading: boolean;

  constructor(
    protected el: ElementRef,
    protected materialsService: MaterialsService,
    protected vendorsService: VendorsService,
    protected matOrderQuery: MatOrderQuery,
    protected matOrderStore: MatOrderStore,
    private route: ActivatedRoute,
    public router: Router,
    private snackBar: MatSnackBar
  ) {
    this.allMaterialsCols = [
      {field: 'name', header: 'Name'},
      {field: 'description', header: 'Description'},
      {field: 'bandingRollLength', header: 'Roll Length (Edgebanding)'},
      {field: 'defaultVendor.name', header: 'Vendor'},
      {field: 'type.name', header: 'Type'},
      {field: 'unitOfIssue.name', header: 'Unit'},
      {field: 'isStock', header: 'Is Stock'},
      {field: 'minStockQty', header: 'Min. Stock'},
      {field: 'inStockCount', header: 'Stock'},
      {field: 'reorderQty', header: 'Reorder qty'},
      {field: 'waste', header: 'Waste %'},
      {field: 'defaultMarkup', header: 'Markup %'},
      {field: 'defaultTaxRate', header: 'Tax %'},
      {field: 'defaultCost', header: 'Cost'},
      {field: 'sellPrice', header: 'Sell Price'}
    ];

    this.allMaterialsCols.forEach((col, index) => {
      this.materialsColsMap.set(index, col.field);
      this.materialsShowsMap.set(col.field, false)
    })

    if(typeof this.selectedMaterialCols === 'undefined' || this.selectedMaterialCols === null) {

      this.selectedMaterialCols = this.allMaterialsCols.map(col => {
        return col.field
      })
    }

    this.fillCols();
  }

  ngOnInit() {
    this.matSearchSubj = this.matOrderQuery.searchQuery$.subscribe(query => {
      if(query !== '') {
        this.searchQuery = query
        this.matOrderStore.updateSearchQuery('')
      }
    })
  }

  ngAfterViewInit() {
    timer(1).subscribe(emit => {
      this.matPerPage = Math.max(this.matPerPage, Math.trunc((this.el.nativeElement.offsetHeight - 150) / 45));
      this.showTypes = false;

      this.loadings.push('vendor')
      this.vendorsService.getVendorsForMaterials().subscribe(vens => {
        this.vendors = vens.map(ven => {
          return {
            label: ven.name,
            value: {
              id: ven.id,
              name: ven.name
            }
          } as SelectItem
        })


        this.vendorItems = vens.map(ven => {
          return {
            label: ven.name,
            value: ven.name
          } as SelectItem
        })

        if (this.storedVendorIds == null) {
          this.selectedVendors = this.vendors.map(v => v.value);
        } else {
          this.selectedVendors = this.vendors
            .filter(v => this.storedVendorIds.includes(v.value.id))
            .map(v => v.value);
        }

        this.loadings.pop();
      })

      this.loadings.push('type')
      this.materialsService.getMaterialTypes().subscribe(types => {
        this.types = types.map(type => {
          return {
            label: type.name,
            value: {
              id: type.id,
              name: type.name
            }
          } as SelectItem
        })

        this.typeItems = types.map(type => {
          return {
            label: type.name,
            value: type.name
          } as SelectItem
        })

        if (this.storedTypeIds == null) {
          this.selectedTypes = this.types.map(t => t.value);
        } else {
          this.selectedTypes = this.types
            .filter(t => this.storedTypeIds.includes(t.value.id))
            .map(t => t.value);
        }

        this.loadings.pop();
      })

      this.loadings.push('units')
      this.materialsService.getUnits().subscribe(units => {

        this.units = units.map(type => {
          return {
            label: type.name,
            value: {
              id: type.id,
              name: type.name
            }
          } as SelectItem
        })
        this.unitItems = units.map(type => {
          return {
            label: type.name,
            value: type.name
          } as SelectItem
        })
        this.loadings.pop();
      })

      this.subToEditable();
      this.subToLoadMaterials()
    })
  }

  fillCols() {
    this.materialsCols = [];
    this.materialsShowsMap = new Map();

    this.selectedMaterialCols.forEach(field => {
      this.materialsShowsMap.set(field, true)
    })

    this.allMaterialsCols.forEach(col => {
      if(this.materialsShowsMap.get(col.field)) {
        this.materialsCols.push(col)
      }
    })
  }

  colsEdited() {
    this.fillCols();
  }

  subToLoadMaterials() {
    this.loadSubj.pipe(debounceTime(500)).subscribe(emit => {
      this.loadMaterials()
    })
  }

  topSearchBar() {
    this.loadSubj.next()
  }

  changeFilter() {
    this.storedVendorIds = this.selectedVendors ? this.selectedVendors.map(v => v.id) : [];
    this.storedTypeIds = this.selectedTypes ? this.selectedTypes.map(t => t.id) : [];
    this.loadSubj.next()
  }

  deleteQuery() {
    this.searchQuery = ''
    this.loadMaterials()
  }

  createMaterial() {
    this.createMaterialLoading = true;

    const newMaterial = new MaterialPage()
    newMaterial.name = 'New Material';
    newMaterial.description = '';
    newMaterial.bandingRollLength = 0;
    newMaterial.isStock = false;
    newMaterial.minStockQty = 0;
    newMaterial.inStockCount = 0;
    newMaterial.reorderQty = 0;
    newMaterial.waste = 0;
    newMaterial.defaultMarkup = 0;
    newMaterial.defaultTaxRate = 0;
    newMaterial.defaultCost = 0;
    newMaterial.sellPrice = 0;


    this.materialsService.createMaterial(newMaterial).subscribe(newMat => {
      this.materials.unshift(newMat)
      this.createMaterialLoading = false;
    }, error => {
      this.createMaterialLoading = false;
    })
  }

  loadMaterials(event?) {

    this.loadings.push('mat')

    this.first = event?.first ? event.first : 0;

    const vendorIds = this.selectedVendors ? this.selectedVendors.map(v => v.id) : [];
    const typeIds = this.selectedTypes ? this.selectedTypes.map(t => t.id) : [];

    this.materialsService.getCustomMaterials(this.first / this.matPerPage, this.matPerPage, this.searchQuery, vendorIds, typeIds).subscribe(materialsResponcePage => {
      this.materialsResponcePage = materialsResponcePage
      this.materials = materialsResponcePage.content

      this.totalElems = materialsResponcePage.totalElements

      this.loadings.pop();
      this.countFooter();

      if(!event) {
        this.materialsTable.reset();
      }
    }, error => {

      this.loadings.pop();
    });
  }

  subToEditable() {
    this.editSubj.pipe(
      debounceTime(250)
    ).subscribe(mat => {
      this.materialsService.updateMaterial(mat).subscribe(emit => {
      })
    })
  }

  startEdit(event) {

    const tempInputs = (this.el.nativeElement as HTMLInputElement).getElementsByClassName('material-input-text');
    if(tempInputs) {
      timer(1).subscribe(emit => {
        const input = tempInputs[0] as HTMLInputElement
        if(input) {

          input.focus()
          input.setSelectionRange(0, input.value.length);
        }
      })
    }
  }

  countFooter() {
    let max = this.matPerPage * (this.first / this.matPerPage + 1);
    max = max < this.totalElems ? max : this.totalElems;

    this.footerString = `${this.first + 1} to ${max} of ${this.totalElems}`;
    // if()
  }


  findType(type: MaterialType) {
    return type.name
  }

  editMaterial(rowData: MaterialPage) {
    this.editSubj.next(rowData)
  }

  deleteMaterial(rowData: MaterialPage) {
    if (!rowData.createdManually) {
      this.snackBar.open('This material was imported from CV, cannot remove it', '', {
        duration: 5000,
        verticalPosition: 'top',
        panelClass: 'error-snackbar',
      });
      return;
    }

    const index = this.materials.findIndex(mat => mat.id === rowData.id)
    if(index >= 0) {
      this.materials.splice(index, 1);
    }

    this.materialsService.deleteMaterial(rowData.id).subscribe(emit => {

    })
  }

  ngOnDestroy(): void {
    this.matSearchSubj.unsubscribe()
  }
}
